import { AlertCircle } from 'lucide-react';
import { cn } from '@/utils/cn';

interface ErrorAlertProps {
  message: string;
  className?: string;
}

/**
 * Tailwind classes match v1's login error block (see `Clinio/src/pages/clinic/Login.tsx`).
 */
export function ErrorAlert({ message, className }: ErrorAlertProps) {
  return (
    <div className={cn('mb-4 rounded-md bg-red-50 p-4 dark:bg-red-900/50', className)}>
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800 dark:text-red-200">{message}</h3>
        </div>
      </div>
    </div>
  );
}
